import { OUTPUTS_ENUM_CHANGED, OUTPUTS_LOGOUT } from "../../const/actionsType";
import { dates } from "investira.sdk";

const INITIAL_STATE = {
  enum: { data: {}, updatedAt: dates.toDate() },
};

function outputsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OUTPUTS_ENUM_CHANGED:
      return {
        ...state,
        enum: {
          data: action.payload,
          updatedAt: dates.toDate(),
        },
      };
    case OUTPUTS_LOGOUT:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
}

export default outputsReducer;
